
import React, { useRef, useEffect, useState } from 'react';
import './HomePage.css';
import SongListItem from '../components/SongListItem';
import SectionListPage from './SectionListPage';

const HomePage = ({ onJumpToCreate }) => {
  const bannerRef = useRef(null);
  const autoScrollTimer = useRef(null);
  

  const [activeSection, setActiveSection] = useState(null);


  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchError, setSearchError] = useState(false);


  useEffect(() => {
    if (searchError) {
      const timer = setTimeout(() => {
        setSearchError(false);
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [searchError]);

  useEffect(() => {
    const startAutoScroll = () => {
      autoScrollTimer.current = setInterval(() => {
        if (bannerRef.current) {
          const { scrollLeft, clientWidth, scrollWidth } = bannerRef.current;
          let nextScroll = scrollLeft + clientWidth;
          if (nextScroll >= scrollWidth - 10) {
            nextScroll = 0;
          }
          bannerRef.current.scrollTo({
            left: nextScroll,
            behavior: 'smooth'
          });
        }
      }, 4000);
    };

    if (!activeSection && !isSearchFocused) { 
      startAutoScroll();
    }

    return () => {
      if (autoScrollTimer.current) clearInterval(autoScrollTimer.current);
    };
  }, [activeSection, isSearchFocused]);

  const handleBannerInteraction = () => {
    if (autoScrollTimer.current) {
      clearInterval(autoScrollTimer.current);
      autoScrollTimer.current = null;
    }
  };

  const handleMakeSimilar = () => {
    if (onJumpToCreate) {
      onJumpToCreate();
    }
  };

  const handleSectionClick = (title) => {
    setActiveSection(title);
    setIsSearchFocused(false);
  };

  const handleGuessTagClick = (tag) => {
    setIsSearchFocused(false); 
    handleMakeSimilar();    
  };

  const handleBackToHome = () => {
    setActiveSection(null);
    setSearchText(''); 
    setSearchError(false);
  };


  const handleSearch = () => {
    if (!searchText.trim()) {
      setSearchError(true); 
    } else {
      setSearchError(false);
      setIsSearchFocused(false);
      setActiveSection('搜索结果'); 
    }
  };

  const handleFocus = () => {
    setIsSearchFocused(true);
    setSearchError(false);
  };

  if (activeSection) {
    return (
      <SectionListPage 
        title={activeSection} 
        onBack={handleBackToHome}
        onItemClick={handleMakeSimilar} 
      />
    );
  }

  return (
    <div className="home-page">
      {/* --- 顶部搜索栏 --- */}
      <div className="search-header">
        <div className="search-box">
          <i className="fas fa-search search-icon"></i>
          <input 
            type="text" 
            className="search-input" 
            placeholder="搜索歌曲、风格..." 
            value={searchText}
            onFocus={handleFocus}
            onChange={(e) => {
              setSearchText(e.target.value);
              if(e.target.value.trim()) setSearchError(false);
            }}
          />
          {isSearchFocused && searchText && (
            <i className="fas fa-times-circle clear-icon" onClick={() => setSearchText('')}></i>
          )}
        </div>
        <button className="search-btn" onClick={handleSearch}>搜索</button>
        {/* 模糊蒙层与猜你喜欢 */}
        {isSearchFocused && (
          <div className="blur-overlay" onClick={() => setIsSearchFocused(false)}>
           <div className="blur-inner">
            <div className="guess-section" onClick={(e) => e.stopPropagation()}>
              <div className="guess-title">猜你喜欢</div>
              <div className="guess-tags">
                <button className="guess-tag" onClick={() => handleGuessTagClick('流行')}>
                  <i className="fas fa-music"></i>
                  <span className="guess-tag-title">流行</span>
                </button>
                <button className="guess-tag" onClick={() => handleGuessTagClick('摇滚')}>
                  <i className="fas fa-guitar"></i>
                  <span className="guess-tag-title">摇滚</span>
                </button>
                <button className="guess-tag" onClick={() => handleGuessTagClick('电子')}>
                  <i className="fas fa-headphones"></i>
                  <span className="guess-tag-title">电子</span>
                </button>
                <button className="guess-tag" onClick={() => handleGuessTagClick('古典')}>
                  <i className="fas fa-star"></i>
                  <span className="guess-tag-title">古典</span>
                </button>
                <button className="guess-tag" onClick={() => handleGuessTagClick('爵士')}>
                  <i className="fas fa-compact-disc"></i>
                  <span className="guess-tag-title">爵士</span>
                </button>
                <button className="guess-tag" onClick={() => handleGuessTagClick('民谣')}>
                  <i className="fas fa-microphone"></i>
                  <span className="guess-tag-title">民谣</span>
                </button>
              </div>
             </div>
            </div>
          </div>
        )}
      </div>
      
      {/* 搜索报错 */}
      {searchError && (
        <div className={`error-msg ${searchError ? '' : 'fade-out'}`}>
          <i className="fas fa-exclamation-circle"></i>
          请输入搜索内容
        </div>
      )}




      {/* --- 原始页面内容 --- */}
      
      {/* 顶部海报轮播 */}
      <div className="banner-carousel h-scrollable">
        <div 
          className="banner-track" 
          ref={bannerRef}
          onTouchStart={handleBannerInteraction}
          onMouseDown={handleBannerInteraction}
        >
            {/* 海报 1 */}
            <div className="banner-item" style={{ background: 'linear-gradient(120deg, #f6d365 0%, #fda085 100%)' }}>
                <div className="banner-content">
                    <span className="banner-tag">热门活动</span>
                    <h2>周杰伦风<br/>编曲大会</h2>
                    <button className="banner-btn" onClick={handleMakeSimilar}>立即参加</button>
                </div>
                <div className="banner-deco-circle"></div>
            </div>
            
            {/* 海报 2 */}
            <div className="banner-item" style={{ background: 'linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%)' }}>
                <div className="banner-content dark-text">
                    <span className="banner-tag" style={{background: '#333', color: '#fff'}}>场景歌单</span>
                    <h2>Lo-fi 陪伴<br/>轻松工作</h2>
                    <button className="banner-btn dark" onClick={() => handleSectionClick('Lo-fi 歌单')}>去聆听</button>
                </div>
                <div className="banner-deco-line"></div>
            </div>

            {/* 海报 3 */}
            <div className="banner-item" style={{ background: 'linear-gradient(to right, #fa709a 0%, #fee140 100%)' }}>
                <div className="banner-content">
                    <span className="banner-tag">一键发行</span>
                    <h2>Apple Music<br/>快捷发行</h2>
                    <button className="banner-btn">查看详情</button>
                </div>
                <i className="fab fa-apple banner-icon"></i>
            </div>
        </div>
      </div>

      {/* 热门歌曲 */}
      <div className="section">
        <div className="section-header clickable" onClick={() => handleSectionClick('热门歌曲')}>
            <h3>热门歌曲</h3>
            <i className="fas fa-chevron-right"></i>
        </div>
        <div className="horizontal-scroll-container h-scrollable">
            {[1, 2, 3, 4].map((item, index) => (
                <div key={index} className="card-item" onClick={handleMakeSimilar}>
                    <div className="card-cover" style={{ 
                        background: `radial-gradient(circle at top right, ${['#8EC5FC', '#E0C3FC', '#85FFBD', '#FF9A9E'][index]}, ${['#E0C3FC', '#8EC5FC', '#FFFB7D', '#FECFEF'][index]})` 
                    }}>
                        <div className="play-icon-mini"><i className="fas fa-play"></i></div>
                        <div className="view-count"><i className="fas fa-headphones"></i> 1.{index + 2}w</div>
                    </div>
                    <div className="card-title">{['第七封未读简讯', '折纸时代的回声', '时光的变奏', '夏日柠檬气泡'][index]}</div>
                    <div className="card-author">{['张三', '刘大大', '李书易', '王小二'][index]}</div>
                </div>
            ))}
        </div>
      </div>

      {/* 流行榜单 */}
      <div className="section">
        <div className="section-header clickable" onClick={() => handleSectionClick('流行榜单')}>
            <h3>流行</h3>
            <i className="fas fa-chevron-right"></i>
        </div>
        <div className="list-container">
            <SongListItem 
                title="句点之后的余温" 
                author="张三" 
                duration="3:45" 
                colorStart="#a18cd1" 
                colorEnd="#fbc2eb"
                onMakeSimilar={handleMakeSimilar}
            />
            <SongListItem 
                title="旋转门与咏叹调" 
                author="刘大大" 
                duration="4:12" 
                colorStart="#84fab0" 
                colorEnd="#8fd3f4"
                onMakeSimilar={handleMakeSimilar}
            />
        </div>
      </div>

      {/* 古风榜单 */}
      <div className="section">
        <div className="section-header clickable" onClick={() => handleSectionClick('古风精选')}>
            <h3>古风</h3>
            <i className="fas fa-chevron-right"></i>
        </div>
        <div className="list-container">
            <SongListItem 
                title="纸飞机上的音符" 
                author="李书易" 
                duration="3:20" 
                colorStart="#cfd9df" 
                colorEnd="#e2ebf0"
                onMakeSimilar={handleMakeSimilar}
            />
            <SongListItem 
                title="留白处的共鸣" 
                author="王小二" 
                duration="2:58" 
                colorStart="#e0c3fc" 
                colorEnd="#8ec5fc"
                onMakeSimilar={handleMakeSimilar}
            />
        </div>
      </div>

      {/* 更多曲风 */}
      <div className="section">
        <div className="section-header clickable" onClick={() => handleSectionClick('更多曲风')}>
            <h3>更多曲风</h3>
            <i className="fas fa-chevron-right"></i>
        </div>
        <div className="grid-container">
            <div className="genre-card" onClick={() => handleSectionClick('古风')} style={{ backgroundImage: 'linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%)' }}>
                <span className="genre-text">古风</span>
                <span className="genre-sub">Classic</span>
            </div>
            <div className="genre-card" onClick={() => handleSectionClick('独立音乐')} style={{ backgroundImage: 'linear-gradient(120deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)' }}>
                <span className="genre-text">独立音乐</span>
                <span className="genre-sub">Indie</span>
            </div>
            <div className="genre-card" onClick={() => handleSectionClick('电子')} style={{ backgroundImage: 'linear-gradient(to top, #30cfd0 0%, #330867 100%)' }}>
                <span className="genre-text">电子</span>
                <span className="genre-sub">Electronic</span>
            </div>
            <div className="genre-card" onClick={() => handleSectionClick('爵士')} style={{ backgroundImage: 'linear-gradient(to top, #ebbba7 0%, #cfc7f8 100%)' }}>
                <span className="genre-text">爵士</span>
                <span className="genre-sub">Jazz</span>
            </div>
        </div>
      </div>

      <div style={{ height: '80px' }}></div>
    </div>
  );
};

export default HomePage;
